// extracted by mini-css-extract-plugin
export default {"backDrop":"BackDrop_backDrop__IYfQr"};